export default __webpack_public_path__ + "static/media/signup.4eeffd29.jpg";